module.exports = __webpack_public_path__ + "media/images/services-hero-9ce1a3766e363df36f6712cd96808847.png";